import React, {useState} from "react";
import {ADMIN_API_BASE} from "../../utils/apiConfig";
import ReCAPTCHA from "react-google-recaptcha";
import logo from "../../assets/Images/logo.svg";
import {TextField} from "@mui/material";
import InputField from "../../components/elements/InputField";
import {Link} from "react-router-dom";
import ButtonLink from "../../components/elements/ButtonLink";
import Wrapper from "../../components/layout/Wrapper";

const SignUser = () => {
    const [step, setStep] = useState(1);
    const [signType, setSignType] = useState(true);
    const [phone, setPhone] = useState("");
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [captchaToken, setCaptchaToken] = useState("");

    const API_BASE = ADMIN_API_BASE;


    const getCsrfToken = async () => {

        const response = await fetch(`${API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include", // critical to send the session cookie
        });

        const data = await response.json();
        return data.csrfToken;
    };

    const handleLogin = async () => {
        if (!captchaToken) {
            setError("Please complete the reCAPTCHA.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const token = await getCsrfToken();

            const response = await fetch(`${API_BASE}/login/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "csrf-token": token,
                    Authorization: `Bearer ${process.env.REACT_APP_ADMIN_TOKEN}`,
                },
                body: JSON.stringify({username, password, captchaToken}),
                credentials: "include", // 👈 Include cookies for session
            });

            const data = await response.json();

            if (response.ok) {
                setStep(2);
                setError("");
            } else {
                setError(data.message || "Invalid credentials.");
            }
        } catch (err) {
            console.error("Login error:", err);
            setError("Something went wrong. Please try again." + err);
        } finally {
            setLoading(false);
        }
    };

    const handleSignup = async () => {

    }

    const handleOtpSubmit = async () => {

        if (!otp) {
            setError("Please enter the OTP.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const token = await getCsrfToken(); // 🧠 Now token is defined here

            const response = await fetch(`${API_BASE}/verify-otp/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "csrf-token": token,
                    Authorization: `Bearer ${process.env.REACT_APP_ADMIN_TOKEN}`,
                },
                body: JSON.stringify({otp}),
                credentials: "include", // 👈 Critical for session!
            });

            const data = await response.json();

            if (response.ok && data.success) {
                // ✅ OTP verified — redirect
                window.location.href = data.redirect;
            } else {
                setError(data.message || "Invalid OTP.");
            }
        } catch (err) {
            console.error("OTP error:", err);
            setError("Verification failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="flex w-full min-h-[89vh] xl:min-h-[91vh] p-8 justify-center items-center">
                <div className="flex flex-col w-full md:w-3/4 lg:w-2/3 xl:w-1/3 p-5 xl:p-10 border-2 border-gray-100 shadow-md rounded-2xl">
                    <Link
                        to="/"
                        className="relative flex items-center mx-auto">
                        <img src={logo} alt="Logo" className="h-16 rounded-sm" />
                        <span className="text-2xl font-bold text-light-primary">کدپرو</span>
                    </Link>
                    <h1 className="text-2xl font-bold mt-8 text-gray-700">
                        {signType === true ? "ورود" : "ثبت نام"}
                    </h1>

                    {error && <p className="text-red-500 text-md mb-2 text-center">{error}</p>}

                    {signType === true ? (
                        <>
                            <InputField
                                type="text"
                                title="شماره تلفن همراه"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                            <ReCAPTCHA
                                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                onChange={(token) => setCaptchaToken(token)}
                            />
                            <ButtonLink
                                onClick={handleLogin}
                                disabled={loading}>
                                <span>{loading ? "در حال انجام..." : "ورود"}</span>
                            </ButtonLink>
                        </>
                    ) : (
                        <>
                            <InputField
                                type="text"
                                title="نام"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <InputField
                                type="text"
                                title="شماره تلفن همراه"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                            <ReCAPTCHA
                                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                onChange={(token) => setCaptchaToken(token)}
                            />
                            <ButtonLink
                                onClick={handleSignup}
                                disabled={loading}>
                            <span>
                            {loading ? "در حال انجام..." : "ثبت نام"}
                                </span>
                            </ButtonLink>
                        </>
                    )}

                    <div className="w-full flex items-center justify-between flex-1 gap-x-3 text-lg text-gray-400 my-8">
                        <span className="h-0.5 bg-gray-300 w-full"></span>
                        <span>یا</span>
                        <span className="h-0.5 bg-gray-300 w-full"></span>
                    </div>

                    <ButtonLink
                        onClick={() => setSignType(!signType)}>
                        <span>{signType ? "ثبت نام" : "ورود"}</span>
                    </ButtonLink>
                </div>
            </div>
            <Wrapper className='flex-col'>
                <div className='relative w-full mb-8 justify-center md:text-lg text-md lg:text-lg flex'>
                    تمامی حقوق
                    <span className='flex items-center ml-2 mr-2 text-light-primary'>
                        <span>کدپرو</span>
                        <img src={logo} alt='logo' className='h-6 block mr-2 rounded-sm'/>
                    </span> محفوظ
                    می
                    باشد &copy;
                </div>
            </Wrapper>
        </>
    );
};

export default SignUser;
